import { render, staticRenderFns } from "./ResultViewContent.vue?vue&type=template&id=6d4bd664&scoped=true"
import script from "./ResultViewContent.vue?vue&type=script&lang=ts"
export * from "./ResultViewContent.vue?vue&type=script&lang=ts"
import style0 from "./ResultViewContent.vue?vue&type=style&index=0&id=6d4bd664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4bd664",
  null
  
)

export default component.exports